import $ from "jquery";

const cartPopupLogin = () => {
  const init = () => {
    // cartPopupLoginFunction();
    showHidePopup();
  };

  // Js haram jangan kayak gini
  // eslint-disable-next-line no-unused-vars
  const cartPopupLoginFunction = () => {
    $(function () {
      $(".js-cart-popup-login input#username").attr("placeholder", "Email *");
      $(".js-cart-popup-login input#password").attr(
        "placeholder",
        "Wachtwoord *"
      );
      $(".js-cart-popup-login .woocommerce-form-login__submit").text(
        "Inloggen"
      );
      $(".js-cart-popup-login p.lost_password a").text("Wachtwoord vergeten?");
    });
  };

  const showHidePopup = () => {
    $(function () {
      $(
        ".js-cart-popup-login .container-content form.js-account-form-login"
      ).attr("autocomplete", "off");

      $(document).on("click", ".js-checkout-button", function (event) {
        event.preventDefault();

        $(".js-cart-popup-login, .js-overlay-cart-popup-login").addClass(
          "active"
        );
      });

      $(document).on("click", ".js-overlay-cart-popup-login", function (event) {
        event.preventDefault();

        $(".js-cart-popup-login, .js-overlay-cart-popup-login").removeClass(
          "active"
        );
      });

      $(document).on("click", ".js-cart-popup-login-close", function (event) {
        event.preventDefault();

        $(".js-cart-popup-login, .js-overlay-cart-popup-login").removeClass(
          "active"
        );
      });
    });
  };

  init();
};

try {
  cartPopupLogin();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
